module.exports = __webpack_public_path__ + "eb55e63b162077da0af3eb62f0525a44.svg";